class ScheduledEmail {
    id: number;
    scheduleId: string;
    sendReport: boolean;
    userId: number;
    userName: string;
    mappingId: number;
    subjectText: string;
    recipients: string;
    formats: EmailFormatEnum;
    bodyText: string;
    drilldownId: number;
    tabId: number;
    tabName: string;
    widgetId: number;
    workbookId: number;
    workbookName: string;
    isHtml: boolean;
    emailCount: number;
    starts: string;
    dateAdded: string;
    get dateAddedFormatted() {
        return formatDateTime(this.dateAdded);
    }
    lastSentDate: string;
    get lastSentDateFormatted() {
        return formatDateTime(this.lastSentDate);
    }
    lastStatus: string;
    scope: ContainerScopeEnum;
    sendEmptyReport: SendEmptyReportEnum;
    widgetIdEmptyReport: number;

    lastEmailSent: boolean;
    lastMessageId: string;
    lastSmtpResponse: string;

    schedule: ScheduledTypeEnum; //EmailSchedule
    scheduledDays: Array<number>;

    scheduledDaysFilter: string;
    scheduledHour: string;
    scheduledHours: Array<string>;
    scheduledEveryMonths: number;
    scheduledOnDay: string;
    scheduledOnDayVal: ScheduledOnDayEnum;
    scheduledOnDayOrdinalNumber: ScheduledOrdinalDayEnum;

    multipleHours: boolean;
    useAddressList: boolean;
    addressListId: number;

    filterId: number;
    companyId: number;
    companyName: string;
    organisationId: number;
    attachments: Array<AttachmentTab>;
    suppressReportHeader: boolean;
    cc: string;
    bcc: string;
    pdfTemplateId: number;
    //config: EmailReportConfig;

    constructor(data = null) {
        this.id = data?.id ?? 0;
        this.scheduleId = data?.scheduleId ?? " ";
        this.sendReport = data ? data.sendReport : true;
        this.subjectText = data?.subjectText ?? "";
        this.recipients = data?.recipients ?? "";
        this.formats = data?.formats ?? EmailFormatEnum.PDF;
        this.bodyText = data?.bodyText ?? "";
        this.drilldownId = data?.drilldownId ?? 0;
        this.tabId = data?.tabId ?? 0;
        this.tabName = data?.tabName ?? "";
        this.widgetId = data?.widgetId ?? 0;

        this.workbookId = data?.workbookId ?? 0;
        this.workbookName = data?.workbookName ?? "";
        this.mappingId = data?.mappingId ?? 0;
        this.userId = data?.userId ?? 0;
        this.userName = data?.userName ?? "";

        this.emailCount = data?.emailCount ?? 0;
        this.dateAdded = data?.dateAdded ?? new Date().toISOString();
        this.lastSentDate = data?.lastSentDate ?? null;
        this.lastStatus = data?.lastStatus ?? null;
        this.scope = data?.scope ?? ContainerScopeEnum.Workbook;
        this.sendEmptyReport = data?.sendEmptyReport ?? SendEmptyReportEnum.Yes;
        this.widgetIdEmptyReport = data?.widgetIdEmptyReport ?? 0;

        this.lastEmailSent = data ? data.lastEmailSent : false;
        this.lastMessageId = data?.lastMessageId ?? "";
        this.lastSmtpResponse = data?.lastSmtpResponse ?? "";

        this.schedule = data?.schedule ?? ScheduledTypeEnum.Daily;
        this.scheduledDays = data?.scheduledDays ??[];
        this.scheduledDaysFilter = data?.scheduledDaysFilter ?? "";
        this.scheduledHour = data?.scheduledHour ?? "08:00:00";
        this.scheduledHours = data?.scheduledHours ?? [];

        this.scheduledEveryMonths = data?.scheduledEveryMonths ?? 1;
        this.scheduledOnDay = data?.scheduledOnDay ?? "";
        this.scheduledOnDayVal = ScheduledOnDayEnum.Sunday;
        this.scheduledOnDayOrdinalNumber = ScheduledOrdinalDayEnum.SpecificDays;
        if (this.scheduledOnDay) {

            if (this.scheduledOnDay.indexOf("#") !== -1) {
                let numbers = this.scheduledOnDay.split("#");
                this.scheduledOnDayVal = parseInt(numbers[0]);
                this.scheduledOnDayOrdinalNumber = parseInt(numbers[1]);
            }
            else {
                this.scheduledOnDayVal = ScheduledOnDayEnum.Day;
                this.scheduledOnDayOrdinalNumber = ScheduledOrdinalDayEnum.Last;
            }
        }

        this.multipleHours = data ? data.multipleHours : false;
        this.useAddressList = data ? data.useAddressList : false;
        this.addressListId = !data || data.addressListId === 0 ? null : data.addressListId;
        this.filterId = !data || data.filterId === 0 ? null : data.filterId;
        this.companyId = !data || data.companyId === 0 ? null : data.companyId;
        this.companyName = data?.companyName ?? "";
        this.organisationId = !data || data.organisationId === 0 ? null : data.organisationId;
        this.attachments = data?.attachments ?? [];
        this.suppressReportHeader = data ? data.suppressReportHeader : false;
        this.cc = data?.cc ?? null;
        this.bcc = data?.bcc ?? null;
        this.pdfTemplateId = data?.pdfTemplateId ?? 0;
        this.starts = data?.starts ?? null;
    }
}

class AttachmentTab {
    id: number;
    tabId: number;
    format: EmailFormatEnum;
    constructor() {
        this.id = 0;
        this.tabId = null;
        this.format = EmailFormatEnum.PDF;
    }
}

enum SendEmptyReportEnum {
    Yes = 0,
    No = 1,
    Notification = 2
}

enum ScheduledDayOfWeekEnum {
    Sunday = 1,
    Monday,
    Tuesday,
    Wednesday,
    Thursday,
    Friday,
    Saturday
}

enum ScheduledOnDayEnum {
    Sunday = 0,
    Monday,
    Tuesday,
    Wednesday,
    Thursday,
    Friday,
    Saturday,
    Day,
    Weekday
}

enum ScheduledOrdinalDayEnum {
    SpecificDays,
    First,
    Second,
    Third,
    Fourth,
    Last
}

enum ScheduledTypeEnum {
    Daily = 'Daily',
    Weekly = 'Weekly',
    Monthly = 'Monthly'
}